import { ObjectRenderer } from '@tier4/autowareviz-threejs';
import * as THREE from 'three';

export class DirectionalObstacleRenderer<T> implements ObjectRenderer<T, THREE.Object3D> {
    private readonly helper = new THREE.ArrowHelper(new THREE.Vector3(1, 0, 0));

    constructor(private underlyingRenderer: ObjectRenderer<T, THREE.Object3D>) {
        this.helper.setColor('red');
        this.helper.setLength(1, 0.2, 0.2);
    }

    render(target: T): THREE.Object3D | undefined {
        const obj = this.underlyingRenderer.render(target);
        if (obj) {
            obj.add(this.helper);
        }
        return obj;
    }

    release(object: THREE.Object3D): void {
        this.underlyingRenderer.release(object);
        this.helper.parent?.remove(this.helper);
    }

    dispose(): void {
        this.underlyingRenderer.dispose();
    }
}
